export default () => ({
	active: false,
	country: window.geo || null,
	projectId: null,
	countries: [],
	geoData: null,
	activeCountry: null,
	run() {
		console.log('Geo run');
		this.fetchGeoData();
	},
	closePopup() {
		this.active = false;
	},
	async fetchGeoData() {

		let apiUrl

		if (this.projectId) {
			console.log('Fetching project data');
			apiUrl = `/api/collections/projects/entries/${this.projectId}`;
		} else {
			console.log('Fetching global data');
			apiUrl = '/api/globals/board_discression_project';
		}

		const response = await fetch(apiUrl);
		const data = await response.json();
		this.geoData = data.data;
		this.countries = data.data.countries;
		// this.activeCountry = data.data.countries;
		const countryFound = data.data.countries.find(country => country.country_code === this.country);
		this.activeCountry = countryFound ? countryFound : null;
		setTimeout(() => {
			this.active = countryFound ? true : false;
		}, 2000);
	}
});
